import { ALTERAR_REGISTROS_POR_PAGINA_EMPRESA } from '../types'

export default function alterarRegistrosPorPaginaEmpresas (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_EMPRESA,
    payload: valor
  }
}
